/* tslint:disable */
/* eslint-disable */
export enum MerchantProcessorAccountType {
  Personal = 'Personal',
  Business = 'Business'
}
